import { fields, createSchema, validate as _validate } from '..';

const { firstName, lastName } = fields;

const schema = createSchema({
  firstName,
  lastName,
});

const validate = (data) => _validate(schema, data);

export default validate;
